export enum OfferTripTypeEnum {
    ONE_WAY = 'ONE-WAY',
    ROUND_TRIP = 'ROUND_TRIP',
}
